export const PENDING = {
  key: 'pending',
  label: '未开始',
  value: 1
}

export const ONGOING = {
  key: 'ongoing',
  label: '正在进行',
  value: 2
}

export const COMPLETED = {
  key: 'completed',
  label: '已完成',
  value: 3
}

export const TEXT_BUTTON = {
  key: 'text',
  value: 0,
  handler: () => {}
}

export const URL_BUTTON = {
  key: 'url',
  value: 1
}

export const YIPAI_BUTTON = {
  key: 'url',
  value: 2,
  getUrl: (v) => {
    return `/bullet/${v}`
  }
}

export const INTERACTION_BUTTON = {
  key: 'interaction',
  value: 3
}

export const BUY_BUTTON = {
  key: 'url',
  value: 4,
  getUrl: (id) => {
    return `/order/confirm/product?id=${id}`
  },
  beforeHandler: async function (id) {
    let product = null
    try {
      const res = await this.$http({
        url: '/product/booking/single/info/get',
        params: {
          id,
          support_webp: window.isSupportWebp
        }
      })
      if (!res || res.error || !res.data) {
        throw new Error(JSON.stringify(res))
      }
      product = res.data
    } catch (error) {
      console.log(error)
    }
    // 获取商品数据
    return product
  }
}

export const CROWDFUNDING_BUTTON = {
  key: 'url',
  value: 5,
  getUrl: (id) => {
    return `/order/confirm/product?id=${id}`
  }
}

export const CROWDFUNDING_MONETARY_TARGET = {
  value: 1,
  label: '已筹金额'
}

export const CROWDFUNDING_QUANTITY_TARGET = {
  value: 2,
  label: '已筹份数'
}
